// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"style_loadingOverlay__W3+XE","loadingIcon":"style_loadingIcon__BipvQ","spin":"style_spin__3u0ql"};